import React from "react";
import {
  Flex,
  Text,
  Box,
} from "@chakra-ui/react";
import Chart from "react-apexcharts";
import Card from "components/Card/Card";
import ExportButton from "components/Reports/ExportCSV";

const PartnerPerformanceChart = ({
  data = [],
  loading,
}) => {
  if (loading) return null;

  const categories = data.map(
    (item) => item.partner_name || "Unknown"
  );

  const values = data.map(
    (item) => item.drivers_referred || 0
  );

  const chartOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },

    xaxis: {
      categories,
      labels: {
        rotate: -45,
        style: {
          colors: "#071D54",
          fontSize: "11px",
        },
      },
      title: {
        text: "Partner",
        style: {
          color: "#071D54",
        },
      },
    },

    yaxis: {
      title: {
        text: "Recruits",
        style: {
          color: "#071D54",
        },
      },
      labels: {
        style: {
          colors: "#071D54",
        },
      },
    },

    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: "50%",
      },
    },

    fill: {
      colors: ["#60A5FA"],
    },

    dataLabels: {
      enabled: false,
    },

    grid: {
      show: false,
    },

    tooltip: {
      theme: "dark",
      y: {
        formatter: (value) =>
          `${value} Recruit${
            value === 1 ? "" : "s"
          }`,
      },
    },
  };

  const chartSeries = [
    {
      name: "Recruits",
      data: values,
    },
  ];

  const exportData = data.map(
    (item) => ({
      Partner:
        item.partner_name ||
        "Unknown",
      "Referral Code":
        item.referral_code,
      Recruits:
        item.drivers_referred,
      Milestones:
        item.milestones_completed,
      Commission:
        item.commission_earned,
    })
  );

  return (
    <Card
      py="1rem"
      height="400px"
      width="100%"
      bg="white"
      position="relative"
    >
      <Box
        position="absolute"
        top="12px"
        right="12px"
      >
        <ExportButton
          data={exportData}
          fileName="partner_performance"
        />
      </Box>

      <Flex
        px={5}
        pt={2}
        pb={3}
        justify="space-between"
      >
        <Text
          color="#071D54"
          fontWeight="bold"
          fontSize="lg"
        >
          Partner Recruitment Performance
        </Text>
      </Flex>

      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        width="100%"
        height="320"
      />
    </Card>
  );
};

export default PartnerPerformanceChart;